import { SET_ORDERBOOK } from './action'

const handleOrderBook = (state, data) => {
  if (data) {
    state = state || {}
    const { symbol, asks, bids } = data
    state[symbol] = { asks: asks.slice(0, 100), bids: bids.slice(0, 100), symbol }
  }
  return state
}

export default (state = null, action) => {
  switch (action.type) {
    case SET_ORDERBOOK:
      return handleOrderBook(state, action.data)
    default:
      return state
  }
}
